import { gql } from '@apollo/client';

export const SALE_CORE_FIELDS = `
  fragment SaleCoreFields on Sale {
    id
    name
    saleOn
    preBidOpenAt
    startAt
    endAt
    status
    bidding
    biddingNotice
    bidGroupChoiceId
    bidGroupBuyerId
    biddingFlash
    biddingFlashBackgroundColor
    biddingFlashForegroundColor
    biddingFlashFades
    saleType
    countdownTimeMs
  }
`;

export const SALES = gql`
  ${SALE_CORE_FIELDS}
  query Sales {
    sales {
      ...SaleCoreFields
      visibleSaleAssetsCount
      previewPhotoUrls(limit: 5)
    }
  }
`;

export const SALE = gql`
  ${SALE_CORE_FIELDS}
  query Sale($id: ID!) {
    sale(id: $id) {
      ...SaleCoreFields
      visibleSaleAssetsCount
    }
  }
`;

export const REGISTER_FOR_SALE = gql`
  mutation RegisterForSale(
    $id: ID!
  ) {
    createSaleBuyerUser(
      id: $id
    ) {
      saleBuyerUser { id, tcSignOffAt }
      errors { path, message }
    }
  }
`;
